<div class="language-switch">
  <button
    class="btn btn-lang"
    [class.active]="currentLocale === localeHK"
    (click)="onLangPicked(localeHK)"
  >
    繁
  </button>
  <button
    class="btn btn-lang"
    [class.active]="currentLocale === localeCN"
    (click)="onLangPicked(localeCN)"
  >
    简
  </button>
  <button
    class="btn btn-lang"
    [class.active]="currentLocale === localeEN"
    (click)="onLangPicked(localeEN)"
  >
    EN
  </button>
</div>
